import React from 'react';
import { Container, Typography } from '@mui/material';

export default function Home() {
  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ textTransform: 'none' }}>
        VeraBIND Tau
      </Typography>
      <Typography paragraph sx={{ textTransform: 'none' }}>
        The VeraBIND™ Tau assay is a novel blood test of tau pathology. Unlike traditional methods that focus on quantifying biomarker levels, the VeraBIND Tau identifies the presence of active tau pathology, which may provide a more direct measure of tau-related disease. A preliminary study of the assay conducted by Veravas and Saint Luc University Hospital, Institute of Neuroscience, UCLouvain have demonstrated the assay’s ability to correctly measure tau pathology in a wide range of patients, including those who are cognitively unimpaired, those with Mild Cognitive Impairment (MCI), and diagnosed with Alzheimer’s disease (AD) dementia.
      </Typography>
    </Container>
  );
 }
